import { render, staticRenderFns } from "./MatchNapPopup.vue?vue&type=template&id=20169f72&scoped=true"
import script from "./MatchNapPopup.vue?vue&type=script&lang=js"
export * from "./MatchNapPopup.vue?vue&type=script&lang=js"
import style0 from "./MatchNapPopup.vue?vue&type=style&index=0&id=20169f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20169f72",
  null
  
)

export default component.exports